import { ZariContext } from '_zari/context'
import { Portlet, Table } from '_zari/core'
import { CodigosTransaccionesConstant } from 'constants/index'
import React from 'react'
import * as UsuariosService from 'services/usuario.service'
import { CambiarContraseniaModal } from '../modals'

const tableHeaderRows = [{ label: 'TRABAJADOR' }, { label: 'NOMBRES' }, { label: 'APELLIDOS' }, { label: '', width: 60 }]

const ListaTrabajadoresPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const [modalCambiarContrasenia, setModalCambiarContrasenia] = React.useState(false)
  const [idSeleccionado, setIdSeleccionado] = React.useState('')

  const tablaRef = React.useRef(null)

  const clickNuevoHandler = e => {
    e.preventDefault()
    history.push(`/${CodigosTransaccionesConstant.CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO}`)
  }

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      await UsuariosService.eliminarxId(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado.')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )
  const clickCambiarContrasenia = React.useCallback(({ _id }) => {
    setIdSeleccionado(_id)
    setModalCambiarContrasenia(true)
  }, [])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO}/${_id}`)
    },
    [history]
  )

  const rowTemplate = React.useCallback(
    row => (
      <Table.Row hover key={row._id}>
        <Table.Cell>{row.username || '--'}</Table.Cell>
        <Table.Cell>{row.nombres || '--'}</Table.Cell>
        <Table.Cell>{row.apellidos || '--'}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                Editar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                Eliminar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='cambiarContrasenia' handleClose={handleClose} onClick={e => clickCambiarContrasenia({ _id: row._id })}>
                Cambiar Contraseña
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [clickEditar, clickEliminar, clickCambiarContrasenia]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Registrar Trabajadores' buttons={[{ name: 'Nuevo', onClick: clickNuevoHandler }]} />
        <Portlet.Body>
          <Table.ServerSide useNest={true} ref={tablaRef} url='/usuarios/por-rol/TRABAJADOR' headRows={tableHeaderRows} rowTemplate={rowTemplate} />
        </Portlet.Body>
      </Portlet>
      {modalCambiarContrasenia && (
        <CambiarContraseniaModal show={modalCambiarContrasenia} handleClose={() => setModalCambiarContrasenia(prev => !prev)} id={idSeleccionado} />
      )}
    </>
  )
}

export default ListaTrabajadoresPage
